import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { colors } from '../../../constants/colors';
import { fontSize, fontFamily } from '../../../constants/text';
import { biggerThan } from '../../../core/util/styledComponents';
import SolvLogo from '../../SolvPatternLibrary/SolvLogo';
import PrivacyLinks from '../../AppFooter/components/PrivacyLinks';

const SmoothDialog = styled(Dialog)`
  -webkit-font-smoothing: antialiased;
  & .dialog-root {
    background-color: ${colors.whiteGrey};

    ${biggerThan.sm`
      padding: 20px 0;
    `}
  }
`;

const Close = styled.div`
  width: 25px;
  height: 25px;
  position: absolute;
  right: 26px;
  top: 20px;
  cursor: pointer;

  &:before {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(45deg);
    background-color: ${colors.blueMonday};
  }

  &:after {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(-45deg);
    background-color: ${colors.blueMonday};
  }
`;

const AboutUsCopy = styled.div`
  color: ${colors.lightText};
  margin: 20px 40px 40px;
  text-align: center;
`;

const PrivacyContainer = styled.div`
  a {
    text-align: center;
    display: block;
    color: ${colors.blueJayWay} !important;
    margin-bottom: 8px;
    font-size: ${fontSize.mediumSmall};
  }
`;

const Header = styled.div`
  color: ${colors.squid};
  font-size: ${fontSize.large};
  font-family: ${fontFamily.bold};
  text-align: center;
  padding-top: 64px;
`;

const CloseLink = styled.div`
  margin: 40px;
  color: ${colors.blueJayWay};
  text-align: center;
  font-size: ${fontSize.default};
  text-transform: uppercase;
  cursor: pointer;
`;

class AboutUsModal extends PureComponent {
  static propTypes = {
    closeModal: PropTypes.func,
    fullScreen: PropTypes.bool,
    open: PropTypes.bool,
  };

  render() {
    const { open, fullScreen, closeModal } = this.props;

    return (
      <SmoothDialog
        open={open}
        closeModal={closeModal}
        maxWidth="sm"
        scroll="body"
        PaperProps={{ classes: { root: 'dialog-root' } }}
        fullScreen={fullScreen}
        fullWidth
        transitionDuration={{ exit: 0 }}
      >
        <Close onClick={closeModal} />
        <Header>
          <SolvLogo width={120} />
        </Header>
        <AboutUsCopy>Great doctors. Available today.</AboutUsCopy>
        <PrivacyContainer>
          <PrivacyLinks />
        </PrivacyContainer>
        <CloseLink onClick={closeModal}>Close</CloseLink>
      </SmoothDialog>
    );
  }
}

export default withMobileDialog({ breakpoint: 'xs' })(AboutUsModal);
